import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CodesParsed } from '../../interfaces/codes.types';

@Component({
  selector: 'app-form-control-date',
  templateUrl: './form-control-date.component.html',
  styleUrls: ['./form-control-date.component.scss']
})
export class FormControlDateComponent implements OnInit {
  @Input() formGroup: FormGroup;
  @Input() inputData: CodesParsed;

  constructor() { }

  ngOnInit() {
  }

}
